export const GET_REPORTED_DATA = 'react-boilerplate/Admin/GET_REPORTED_DATA';
export const ACCEPT_REPORTED_DATA = 'react-boilerplate/Admin/ACCEPT_REPORTED_DATA';
export const DECLINE_REPORTED_DATA = 'react-boilerplate/Admin/DECLINE_REPORTED_DATA';
export const CHANGE_SHOPPING_CART_VALUE = 'react-boilerplate/Admin/CHANGE_SHOPPING_CART_VALUE';

export type ReportedDataApi = 'reports' | 'subscriptionsreport';
export type ReportedDataId = string | number;
export type ReportedCsvRow = string[];
export type ReportedDataIds = Array<ReportedDataId | ReportedCsvRow>;

export const getReportedData = (params: string, api: ReportedDataApi) => ({
  type: GET_REPORTED_DATA,
  field: api,
  meta: {
    type: 'api',
    url: `admin/${api}/pending?${params}`,
    method: 'get',
  },
});

export const acceptReportedData = (
  reportedDataIDs: ReportedDataIds,
  api: ReportedDataApi,
) => ({
  type: ACCEPT_REPORTED_DATA,
  field: api,
  meta: {
    type: 'api',
    url: `admin/${api}/accept`,
    method: 'post',
    data: { ids: reportedDataIDs },
  },
});

export const declineReportedData = (
  reportedDataIDs: ReportedDataIds,
  api: ReportedDataApi,
) => ({
  type: DECLINE_REPORTED_DATA,
  field: api,
  meta: {
    type: 'api',
    url: `admin/${api}/decline`,
    method: 'post',
    data: { ids: reportedDataIDs },
  },
});

export const changeShoppingCartValue = (
  reportId: ReportedDataId,
  newCartValue: string,
) => ({
  type: CHANGE_SHOPPING_CART_VALUE,
  meta: {
    type: 'api',
    url: 'admin/reports/edit',
    method: 'post',
    data: { id: reportId, newValue: newCartValue },
  },
  newValue: newCartValue,
});
